import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaBirthdayCake, FaGift, FaSpa } from 'react-icons/fa';
import { BsDuffleFill } from "react-icons/bs";


const addOnDisplayData = {
  birthday_celebration: {
    name: 'Birthday Celebration',
    icon: <FaBirthdayCake />,
  },
  grooming_kits: {
    name: 'Grooming Kits',
    icon: <BsDuffleFill />,
  },
  spa: {
    name: 'Spa Session',
    icon: <FaSpa />,
  },
  pet_accessories: {
    name: 'Pet Accessories',
    icon: <FaGift />,
  },
};

const SectionAddOns = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {selectedOptions.map(option => {
          const addOn = addOnDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{addOn?.icon}</span>
              <span>{addOn?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionAddOns;
